export function GetOfferSection() {
  return (
    <section id="get-offer" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Get Your Free Cash Offer Today
          </h2>
          <p className="text-xl text-gray-600">
            Fill out the form below to receive a no-obligation cash offer for your duplex, triplex, quadplex, or small apartment building within 24-48 hours.
          </p>
        </div>

        <div className="bg-gradient-to-br from-amber-50 to-white rounded-2xl shadow-2xl p-8 lg:p-12">
          <form className="space-y-6" data-readdy-form id="small-apartment-offer-form">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="firstName" className="block text-sm font-semibold text-gray-900 mb-2">
                  First Name *
                </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder="John"
                />
              </div>

              <div>
                <label htmlFor="lastName" className="block text-sm font-semibold text-gray-900 mb-2">
                  Last Name *
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder="Smith"
                />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-gray-900 mb-2">
                  Email Address *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder="john@example.com"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-semibold text-gray-900 mb-2">
                  Phone Number *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder="(555) 123-4567"
                />
              </div>
            </div>

            <div>
              <label htmlFor="propertyAddress" className="block text-sm font-semibold text-gray-900 mb-2">
                Property Address *
              </label>
              <input
                type="text"
                id="propertyAddress"
                name="propertyAddress"
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                placeholder="123 Main Street, City, State, ZIP"
              />
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="propertyType" className="block text-sm font-semibold text-gray-900 mb-2">
                  Property Type *
                </label>
                <select
                  id="propertyType"
                  name="propertyType"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                >
                  <option value="">Select property type</option>
                  <option value="duplex">Duplex (2 Units)</option>
                  <option value="triplex">Triplex (3 Units)</option>
                  <option value="quadplex">Quadplex (4 Units)</option>
                  <option value="5-unit">5-Unit Building</option>
                  <option value="6-plus">6+ Units</option>
                </select>
              </div>

              <div>
                <label htmlFor="propertyCondition" className="block text-sm font-semibold text-gray-900 mb-2">
                  Property Condition *
                </label>
                <select
                  id="propertyCondition"
                  name="propertyCondition"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                >
                  <option value="">Select condition</option>
                  <option value="excellent">Excellent - Move-in Ready</option>
                  <option value="good">Good - Minor Repairs Needed</option>
                  <option value="fair">Fair - Some Repairs Needed</option>
                  <option value="poor">Poor - Major Repairs Needed</option>
                  <option value="vacant">Vacant</option>
                </select>
              </div>
            </div>

            <div>
              <label htmlFor="occupancyStatus" className="block text-sm font-semibold text-gray-900 mb-2">
                Occupancy Status *
              </label>
              <select
                id="occupancyStatus"
                name="occupancyStatus"
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
              >
                <option value="">Select occupancy status</option>
                <option value="fully-occupied">Fully Occupied</option>
                <option value="partially-occupied">Partially Occupied</option>
                <option value="vacant">Completely Vacant</option>
                <option value="owner-occupied">Owner Occupied (One Unit)</option>
              </select>
            </div>

            <div>
              <label htmlFor="timeline" className="block text-sm font-semibold text-gray-900 mb-2">
                When Do You Want to Sell? *
              </label>
              <select
                id="timeline"
                name="timeline"
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
              >
                <option value="">Select timeline</option>
                <option value="asap">As Soon As Possible</option>
                <option value="1-month">Within 1 Month</option>
                <option value="1-3-months">1-3 Months</option>
                <option value="3-6-months">3-6 Months</option>
                <option value="just-exploring">Just Exploring Options</option>
              </select>
            </div>

            <div>
              <label htmlFor="additionalInfo" className="block text-sm font-semibold text-gray-900 mb-2">
                Additional Information (Optional)
              </label>
              <textarea
                id="additionalInfo"
                name="additionalInfo"
                rows={4}
                maxLength={500}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm resize-none"
                placeholder="Tell us anything else about your property or situation that might be helpful..."
              ></textarea>
              <p className="text-sm text-gray-500 mt-1">Maximum 500 characters</p>
            </div>

            <button
              type="submit"
              className="w-full px-8 py-4 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition-colors whitespace-nowrap flex items-center justify-center"
            >
              Get My Free Cash Offer
              <i className="ri-arrow-right-line ml-2"></i>
            </button>

            <p className="text-sm text-gray-600 text-center">
              By submitting this form, you agree to be contacted about your property. We respect your privacy and will never share your information.
            </p>
          </form>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6 text-center">
          <div className="bg-amber-50 p-6 rounded-xl">
            <i className="ri-shield-check-line text-4xl text-orange-500 mb-3"></i>
            <h3 className="font-bold text-gray-900 mb-2">No Obligation</h3>
            <p className="text-sm text-gray-600">Get your offer with zero commitment or pressure</p>
          </div>
          <div className="bg-amber-50 p-6 rounded-xl">
            <i className="ri-time-line text-4xl text-orange-500 mb-3"></i>
            <h3 className="font-bold text-gray-900 mb-2">Fast Response</h3>
            <p className="text-sm text-gray-600">Receive your cash offer within 24-48 hours</p>
          </div>
          <div className="bg-amber-50 p-6 rounded-xl">
            <i className="ri-lock-line text-4xl text-orange-500 mb-3"></i>
            <h3 className="font-bold text-gray-900 mb-2">Confidential</h3>
            <p className="text-sm text-gray-600">Your information is secure and private</p>
          </div>
        </div>
      </div>
    </section>
  );
}